import { render, staticRenderFns } from "./shopingcart.vue?vue&type=template&id=b084cac8&scoped=true"
import script from "./shopingcart.vue?vue&type=script&lang=js"
export * from "./shopingcart.vue?vue&type=script&lang=js"
import style0 from "./shopingcart.vue?vue&type=style&index=0&id=b084cac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b084cac8",
  null
  
)

export default component.exports